import { render, staticRenderFns } from "./ComplementaryMedicalServices.vue?vue&type=template&id=32c29bca&"
import script from "./ComplementaryMedicalServices.vue?vue&type=script&lang=js&"
export * from "./ComplementaryMedicalServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports